import * as React from 'react';

import type { BillableWorkRM } from 'ab-requestModels/reportType/reportType.requestModel';

import styles from './styles.module.scss';

interface OwnProps {
	billableWork: BillableWorkRM;
}

type Props = OwnProps;

const BillingTypeInfo: React.FC<Props> = (props) => {
	const { isMaterialCost, isBillableWork, materialGroups } = props.billableWork;

	return (
		<div className={styles.BillingTypeInfo}>
			{isBillableWork && (<div className={styles.label}>Billable Work</div>)}
			{isMaterialCost && (<div className={styles.label}>Material Cost: {materialGroups?.join(', ')}</div>)}
		</div>
	);
};

export default React.memo(BillingTypeInfo);
